import React, { useState } from 'react';

import { useParams, useSearchParams } from 'react-router-dom';

import { useAppSelector, useAppDispatch } from '../../../app/hooks';
import {
  selectLogged,
} from './sessionSlice';
import { useAuthAuthorizedQuery, useInitQuery } from '../../../api/index';
import styles from './Session.module.css';

export function Authorized() {
	//const state = useAppSelector(selectState);
	const dispatch = useAppDispatch();
	let params = useParams();
	let [urlSearchParams] = useSearchParams();
	console.log('params', params);
	console.log('searchParams', urlSearchParams);

	let authState = urlSearchParams.get("state");
	let authCode = urlSearchParams.get("code");
	if (!authState || !authCode) {
		authState = "";
		authCode = "";
	}
	/*
	if (urlSearchParams.code
		&& urlSearchParams.code
	&& urlSearchParams.state
	&& urlSearchParams.state)
	const {
		data: note,
		isLoading,
		isSuccess,
		isError,
		error
	} = useAuthAuthorizedQuery({
		state: authState,
		code: authCode,
	})
	// */

	const {
		data: user,
		isLoading,
		isSuccess,
		isError,
		error
	} = useInitQuery()
	console.log('DiscordUser: ', user);
	// */

	return (
		<div>
			<div className={styles.row}>
				Authorized Page
			</div>
			<div className={styles.row}>
				<ul>
					<li>Authorized List Item</li>
				</ul>
			</div>
		</div>
	);
}
